import React, { CSSProperties } from "react";

export default function IconVolumeUp(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M3 10V14C3 14.55 3.45 15 4 15H7L10.29 18.29C10.92 18.92 12 18.47 12 17.58V6.41002C12 5.52002 10.92 5.07002 10.29 5.70002L7 9.00002H4C3.45 9.00002 3 9.45002 3 10ZM16.5 12C16.4998 11.1621 16.2657 10.341 15.824 9.62896C15.3823 8.91696 14.7506 8.34241 14 7.97002V16.02C15.48 15.29 16.5 13.77 16.5 12ZM14 4.45002V4.65002C14 5.03002 14.25 5.36002 14.6 5.50002C17.18 6.53002 19 9.06002 19 12C19 14.94 17.18 17.47 14.6 18.5C14.24 18.64 14 18.97 14 19.35V19.55C14 20.18 14.63 20.62 15.21 20.4C18.6 19.11 21 15.84 21 12C21 8.16002 18.6 4.89002 15.21 3.60002C14.63 3.37002 14 3.82002 14 4.45002Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
